import React from "react";

import gettext from "../../shared/utils/gettext";
import DashboardTile from "../DashboardTile";

const UpgradeTile = () => {
  const extraClasses = ["background-lightyellow"];
  return (
    <DashboardTile experimental extra={extraClasses}>
      <DashboardTile.Title extra={extraClasses}>{gettext("Upgrade to pro")}</DashboardTile.Title>
      <DashboardTile.Body>
        {gettext("Upgrade to a pro subscription now to make use of our advanced features.")}
        {/*todo plaatje*/}
      </DashboardTile.Body>
      <DashboardTile.Link
        url="https://www.dacom.nl/nl/producten/teeltregistratie/"
        text={gettext("See benefits")}
        experimental
        logMetrics={true}
      />
    </DashboardTile>
  );
};
export default UpgradeTile;
